import { render } from "./fueltype.vue?vue&type=template&id=db2de2e4"
import script from "./fueltype.vue?vue&type=script&lang=js"
export * from "./fueltype.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__